import { FunctionComponent, useState, useRef, useEffect } from "react";
import styles from "./DeleteRecordsModal.module.css";
import Modal from "react-modal";
import { connect, useDispatch } from "react-redux";
import Loading from "../../Loading/Loading";
import Dropdown from "../../DropDown/Dropdown";
import { showSnackbarAction } from "../../../Redux/actions";
import { DeleteRecords } from "../../../Services/users";

// -------------------------------------------------------------
// Props expected by the modal
// -------------------------------------------------------------
type props = {
  open: boolean;
  close: () => void;
  filterData: any[] | undefined;
  organizationUsers: any;
  organizationId: string;
};

// -------------------------------------------------------------
// Delete Records Modal Component
// -------------------------------------------------------------
const DeleteRecordsModal: FunctionComponent<props> = ({
  open,
  close,
  filterData,
  organizationUsers,
  organizationId,
}) => {
  // Redux dispatcher
  const dispatcher = useDispatch();

  // Loader state
  const [load, setLoad] = useState(false);

  // Selected user email from dropdown
  const [emailSelected, setEmailSelected] = useState<any>({ label: "Select", value: "Select" });

  // Mapping email → UID for quick lookup
  const [uid, setUid] = useState<any>();

  // List of all emails (dropdown options)
  const [User_Email, setEmail] = useState<any[]>();

  // -------------------------------------------------------------
  // Populate email list + uid mapping from organizationUsers
  // Runs once whenever organizationUsers changes
  // -------------------------------------------------------------
  useEffect(() => {
    let uids: { [key: string]: string } = {};
    let emails: any[] = [];
    organizationUsers.forEach((item: any) => {
      emails.push(item.user_email);
      uids[item.user_email] = item.uid;
    });
    setEmail(emails);
    setUid(uids);
  }, [organizationUsers]);

  // -------------------------------------------------------------
  // SAVE — Validate selection & invoke DeleteRecords service
  // -------------------------------------------------------------
  const onSave = () => {
    if (emailSelected.value === "" || emailSelected.value === "Select") {
      dispatcher(showSnackbarAction("Please Select A User!!", "error"));
    } else {
      setLoad(true);
      DeleteRecords(
        uid[emailSelected.value],
        organizationId,
        dispatcher,
        (data) => setLoad(data),
        close
      );
    }
  };

  // -------------------------------------------------------------
  // UI Rendering
  // -------------------------------------------------------------
  return (
    <Modal
      isOpen={open}
      className={styles.parent}
      overlayClassName={styles.overlay}
      onRequestClose={close}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
    >

      {/* Loader animation */}
      {load && <Loading />}

      {/* Modal Header */}
      <div className={styles.headingContainer}>
        <p className={styles.heading}>Delete Records</p>
      </div>

      {/* User Email Dropdown */}
      <div style={{ marginTop: "50px", width: "100%" }}>
        <Dropdown
          option={User_Email}
          selectedValue={emailSelected}
          setSelectedValue={(value) => setEmailSelected(value)}
        />
      </div>

      {/* Footer Buttons */}
      <div className={styles.buttonView}>
        <button className={styles.cancelButton} onClick={close}>
          Cancel
        </button>
        <button className={styles.saveButton} onClick={onSave}>
          Save
        </button>
      </div>
    </Modal>
  );
};

// -------------------------------------------------------------
// Redux: Mapping store state to props
// -------------------------------------------------------------
const mapStateToProps = (state: any) => {
  return {
    organizationId: state.organization.id,
    organizationUsers: state.organizationUsers.data,
  };
};

export default connect(mapStateToProps)(DeleteRecordsModal);
